import { useIdleTimer } from 'react-idle-timer'
import { useAuth } from '@/contexts/auth.context'
import { setSessionExpired } from '@/storage/local-storage'

export function SessionTimeout() {
  const { logout, authenticated } = useAuth()

  const onIdle = async () => {
    setSessionExpired(true)
    await logout()
  }

  useIdleTimer({
    timeout: 15 * 60 * 1000, // 15 minutes
    onIdle,
    debounce: 500,
    disabled: !authenticated, // Only enable the timer when authenticated
  })

  return null // This component doesn't render anything
}
